@if (categories.length > 0) {
  <div class="category-card-grid">
    @for (category of categories; track category.id) {
      <button
        type="button"
        class="category-card-option"
        [class.selected]="category.id === selectedCategoryId"
        [attr.aria-pressed]="category.id === selectedCategoryId"
        (click)="selectCategory(category)">
        <app-category-icon [icon]="category.icon" [size]="26"></app-category-icon>
        <span class="card-name">{{ category.name }}</span>
        <app-category-env-badge
          [isIndoor]="category.isIndoor || false"
          [onSelected]="category.id === selectedCategoryId">
        </app-category-env-badge>
      </button>
    }
  </div>
}
